<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cqW1MZ/tc-custom/9783968653464.jpg" alt="This image is the cover for the book Ein tragisches Geheimnis, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ein tragisches Geheimnis, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Julian Hawthorne, der Sohn von Nathaniel Hawthorn schrieb diesen Kriminalroman um den New Yorker Inspektor Byrnes, der ein tragisches Geheimnis aufzuklären hat. Ein New Yorker Ladenbesitzer wird ermordet. Doch die Tat erscheint ohne Motiv, nichts wurde gestohlen. Alles deutet auf eine anderes, privateres Motiv hin. in Anlehnung an den Manhatten Banküberfall im Jahr 1878. Die Tagebucheinträge eines gewissen Inspektor Byrnes ergeben den Handlungsfaden.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julian Hawthorne
      </h2>
      
      <p class="authorDescription body article">Julian Hawthorne (June 22, 1846 – July 14, 1934) war ein amerikanischer Schriftsteller und Journalist. Er war der Sohn  von Hawthorne und Sophia Peabody. Er schrieb zahlreiche Gedichte, Romane , Kurzgeschichten und Mystery/Detektivgeschichten.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTBeBook Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0be74745